<h2 mat-dialog-title>Configurar Colunas</h2>
<mat-dialog-content>
  <p class="description-text">Selecione abaixo quais informações deseja que estejam visíveis</p>
  <div class="column-list">
    <!-- Pinned Start -->
    @for (col of pinnedStart; track col) {
      <div class="column-item">
        <div class="drag-placeholder"></div>
        <mat-checkbox [(ngModel)]="col.visible" [disabled]="col.fixed">
          {{ col.label }}
        </mat-checkbox>
      </div>
    }

    <!-- Movable List -->
    <div cdkDropList (cdkDropListDropped)="drop($event)">
      @for (col of movable; track col) {
        <div class="column-item" cdkDrag>
          <div class="drag-handle" cdkDragHandle>
            <mat-icon>drag_indicator</mat-icon>
          </div>
          <!-- Custom Preview to ensure styling -->
          <div *cdkDragPreview class="column-item item-preview">
            <div class="drag-handle"><mat-icon>drag_indicator</mat-icon></div>
            <mat-checkbox [checked]="col.visible" [disabled]="true">{{ col.label }}</mat-checkbox>
          </div>
          <mat-checkbox [(ngModel)]="col.visible" [disabled]="col.fixed">
            {{ col.label }}
          </mat-checkbox>
        </div>
      }
    </div>

    <!-- Pinned End -->
    @for (col of pinnedEnd; track col) {
      <div class="column-item">
        <div class="drag-placeholder"></div>
        <mat-checkbox [(ngModel)]="col.visible" [disabled]="col.fixed">
          {{ col.label }}
        </mat-checkbox>
      </div>
    }
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button class="btn-secondary" mat-dialog-close>Cancelar</button>
  <button mat-flat-button class="btn-primary" (click)="confirm()">Confirmar</button>
</mat-dialog-actions>
